import React from 'react';
import { ArrowUpDown, PlayCircle, PauseCircle } from 'lucide-react';

interface ControlPanelProps {
    onLanguageToggle: () => void;
    onPlayToggle: () => void;
    onResourcesClick: () => void;
    language: 'english' | 'greek';
    isPlaying: boolean;
}

const ControlPanel: React.FC<ControlPanelProps> = ({ onLanguageToggle, onPlayToggle, onResourcesClick, language, isPlaying }) => {
    return (
        <div className="inline-block bg-stone rounded-lg shadow-lg border-2 border-terracotta">
            <div className="flex flex-col items-center space-y-2 p-2">
                <button
                    className="w-32 bg-terracotta text-warm-cream font-cinzel font-bold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-golden-yellow flex items-center justify-center"
                    onClick={onLanguageToggle}
                >
                    <ArrowUpDown className="mr-2" size={20} />
                    {language === 'english' ? 'Greek' : 'English'}
                </button>
                <button
                    className={`w-32 font-cinzel font-bold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-golden-yellow flex items-center justify-center
                        ${language === 'greek'
                            ? 'bg-aegean-blue text-warm-cream'
                            : 'bg-stone-light text-greek-black cursor-not-allowed'
                        }`}
                    onClick={onPlayToggle}
                    disabled={language === 'english'}
                >
                    {isPlaying ? (
                        <>
                            <PauseCircle className="mr-2" size={20} />
                            Pause
                        </>
                    ) : (
                        <>
                            <PlayCircle className="mr-2" size={20} />
                            Play
                        </>
                    )}
                </button>
                <button
                    className="w-32 bg-golden-yellow text-warm-cream font-cinzel font-bold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-golden-yellow flex items-center justify-center"
                    onClick={onResourcesClick}
                >
                    <ArrowUpDown className="mr-2" size={20} />
                    Resources
                </button>
            </div>
        </div>
    );
};

export default ControlPanel;